import React from "react";
import { cn } from "../../lib/cn";

export function Avatar({ src, alt, size = 36, shape = "circle", style, children, className }) {
  const r = shape === "circle" ? "rounded-full" : "rounded-lg";

  const dim = typeof size === "number" ? { width: size, height: size } : {};

  const styleMerged = {
    ...(typeof size === "object" ? size : dim),
    ...style,
  };

  return (
    <span
      className={cn(
        "inline-flex items-center justify-center overflow-hidden bg-slate-100 text-xs font-semibold text-slate-600 ring-2 ring-white",
        r,
        className
      )}
      style={styleMerged}
    >
      {src ? (
        <img alt={alt || ""} src={src} className="h-full w-full object-cover" />
      ) : (
        children
      )}
    </span>
  );
}

Avatar.Group = function AvatarGroup({
  children,
  maxCount,
  maxStyle,
  style,
  className,
}) {
  const arr = React.Children.toArray(children).filter(Boolean).slice(
    0,
    maxCount ?? undefined
  );
  return (
    <div style={style} className={cn("flex flex-row-reverse justify-end [&>*]:-ml-2", className)}>
      {[...arr].reverse().map((c, i) => (
        <React.Fragment key={i}>{c}</React.Fragment>
      ))}
      {(maxCount && React.Children.count(children) > maxCount) ? (
        <span
          className="relative z-[1] flex h-10 w-10 items-center justify-center rounded-full border-2 border-white bg-slate-200 text-[10px] font-bold text-slate-700"
          style={maxStyle}
        >
          +{React.Children.count(children) - maxCount}
        </span>
      ) : null}
    </div>
  );
};
